import { CookieKeys, Cookies } from "../utils/cookieKey";
import { isValEmpty } from "../utils/common";
const userInfo =Cookies.get(CookieKeys.userInfo)?JSON.parse(Cookies.get(CookieKeys.userInfo)):{
  userId: "",
  dwmc: "",
  linkName: "",
  zhiwu: "",
}
const basic = {
  namespaced: true,
  state: {
    pageTitle: "",
    userInfo: userInfo,
    isShowDialogLogin: false,
    loginSuccessGo: {
      // type: "open",
      // url: process.env.VUE_APP_OLD_USER_CENTER_URL,
    },
    isShowDialogInformationImprove: false,
    isShowDialogInformationImproveFrom: "",
    loginConfig: {
      //是否显示弹窗、默认登录方式和是否隐藏扫码登录相关功能
      // showPopup: 1, //显示弹窗 0 否 1 是
      // defaultLoginType: 1, //登陆方式 0 快捷登陆 1 扫码登陆
      // hideQrCodeLogin: 1, //隐藏扫码登录 0 否 1 是
    },
  },
  getters: {
    pageTitle: (state) => state.pageTitle,
    userInfo: (state) => state.userInfo,
    isPayBefore: (state) => {
      return state.userInfo.isPayBefore || state.userInfo.memberLevel > 5;
    },
    isLogin: (state) => {
      let CookiesStatus =
        (Cookies.get(CookieKeys.qlm_username) && Cookies.get(CookieKeys.qlm_password)) ||
        Cookies.get(CookieKeys.userInfo);
      return CookiesStatus && !isValEmpty(state.userInfo);
    },
    isShowDialogLogin: (state) => state.isShowDialogLogin,
    loginSuccessGo: (state) => state.loginSuccessGo,
    isShowDialogInformationImprove: (state) => state.isShowDialogInformationImprove,
    isShowDialogInformationImproveFrom: (state) => state.isShowDialogInformationImproveFrom,
    loginConfig: (state) => state.loginConfig,
  },
  mutations: {
    updatePageTitle(state, pageTitle) {
      state.pageTitle = pageTitle;
    },
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      Cookies.set(CookieKeys.userInfo, JSON.stringify(userInfo), { domain: ".qianlima.com" });

    },
    updateIsShowDialogLogin(state, isShowDialogLogin) {
      state.isShowDialogLogin = isShowDialogLogin;
    },
    updateLoginSuccessGo(state, loginSuccessGo) {
      state.loginSuccessGo = loginSuccessGo;
    },
    updateIsShowDialogInformationImprove(state, isShowDialogInformationImprove) {
      state.isShowDialogInformationImprove = isShowDialogInformationImprove;
    },
    updateIsShowDialogInformationImproveFrom(state, isShowDialogInformationImproveFrom) {
      state.isShowDialogInformationImproveFrom = isShowDialogInformationImproveFrom;
    },
    updateLoginConfig(state, loginConfig) {
      state.loginConfig = loginConfig;
    },
  },
  actions: {},
};
export default basic;
